import { ArrowLeft, ChevronLeft } from 'lucide-react'

interface BackButtonProps {
  onClick: () => void
  label?: string
}

/**
 * "Voltar" das telas de detalhe em Ocorrências e Atendimento HUB (thread de
 * ocorrência, thread de problema, formulário de novo problema). Com borda e
 * cor pra não se perder no cabeçalho — antes era só texto cinza.
 */
export function BackButton({ onClick, label = 'Voltar' }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-md border border-blue-300 bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700 transition hover:border-blue-400 hover:bg-blue-100 dark:border-blue-700 dark:bg-blue-900/20 dark:text-blue-300 dark:hover:bg-blue-900/40"
    >
      <ArrowLeft className="h-3.5 w-3.5" aria-hidden />
      {label}
    </button>
  )
}

/** Voltar quadrado só com a seta — cabeçalhos de página (processo aberto,
 * Atendimento HUB). */
export function IconBackButton({ onClick, label }: { onClick: () => void; label: string }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-border-subtle bg-surface text-body transition hover:bg-surface-muted"
    >
      <ChevronLeft className="h-5 w-5" />
    </button>
  )
}

/** Voltar em texto azul com seta ("‹ Ocorrências do processo", "‹ Chamados")
 * — topo das conversas. */
export function TextBackLink({ onClick, label }: { onClick: () => void; label: string }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 transition hover:text-blue-700 dark:text-blue-400"
    >
      <ChevronLeft className="h-4 w-4" />
      {label}
    </button>
  )
}
